import React, { Component } from 'react';

class Income extends Component {
    render() {
        const { data } = this.props;
        return (
            <div className="row compared-list">
                <div className="content">
                    <div className="title">
                        预算完成率（Budget%）
                        <br />
                        Top 10
                    </div>
                    {[
                        "Wyndham Grand Plaza Royale Yuzhou Xiamen 厦门禹洲温德姆至尊豪廷大酒店",
                        "Howard Johnson Plaza Ningbo 宁波华侨豪生大酒店",
                        "Howard Johnson Jinyi Hotel Chongqing 重庆锦怡豪生酒店",
                        "Howard Johnson Paragon Hotel Beijing 北京宝辰饭店",
                        "Wyndham Grand Plaza Royale Kaidi 凯迪温德姆至尊豪廷大酒店",
                        "Howard Johnson Tech Center Plaza Hefei 合肥两淮豪生大酒店",
                        "Howard Johnson Jimei Lake Plaza Xiamen 厦门集美湖豪生大酒店",
                        "Howard Johnson Pearl Plaza Wuhan 江城明珠豪生大酒店",
                        "Howard Johnson Hi-Tech Plaza Chengdu 成都高新豪生大酒店",
                        "Howard Johnson Tropical Garden Plaza Kunming 昆明南亚风情园豪生大酒店",
                    ].map((x, i) => {
                        return (
                            <div className="item" key={x}>
                                <div>{i + 1}</div>
                                <div>
                                    {x.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.replace(/[^\u4E00-\u9FA5]/g, "")}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="content">
                    <div className="title">
                        收入较去年增长幅度（Rev. vs LY%)
                        <br />
                        Top 10
                    </div>
                    {[
                        "Howard Johnson Xiangyu Plaza Linyi 山东临沂翔宇豪生大酒店",
                        "Wyndham Grand Plaza Royale Huayu Chongqing 重庆华宇温德姆至尊豪廷大酒店",
                        "Howard Johnson Riverview Hotel Guangzhou 广州桃花江豪生酒店",
                        "Wyndham Grand Plaza Royale Kaidi 凯迪温德姆至尊豪廷大酒店",
                        "Howard Johnson Yacht Club Hotel Changsha 长沙湘江豪生酒店",
                        "Wyndham Grand Plaza Royale Chenzhou 郴州温德姆至尊豪廷大酒店",
                        "Howard Johnson Huachen Plaza Changsha 长沙华晨豪生大酒店",
                        "Howard Johnson Sunshine Plaza Ningbo 宁波阳光豪生大酒店",
                        "Wyndham Grand Plaza Royale Mingfa Zhangzhou 漳州明发温德姆至尊豪廷大酒店",
                        "Howard Johnson Zunyue Hotel Chengdu 成都尊悦豪生酒店",
                    ].map((x, i) => {
                        return (
                            <div className="item" key={x}>
                                <div>{i + 1}</div>
                                <div>
                                    {x.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.replace(/[^\u4E00-\u9FA5]/g, "")}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="content">
                    <div className="title">
                        客人评分（WYN Review - Medallia）
                        <br />
                        Top 10
                    </div>
                    {[
                        "Wyndham Grand Plaza Royale Wenchang 文昌温德姆至尊豪廷大酒店",
                        "Howard Johnson Kangda Plaza Qingdao 青岛康大豪生大酒店",
                        "Howard Johnson Dream Sea Resort Weihai 威海香海豪生度假酒店 ",
                        "Wyndham Grand Plaza Royale Chenzhou 郴州温德姆至尊豪廷大酒店",
                        "Howard Johnson Tianzhu Plaza Fuyang 阜阳天筑豪生大酒店",
                        "Howard Johnson Hot Spring Resort Anshun 安顺豪生温泉度假酒店",
                        "Wyndham Grand Plaza Royale Furongguo Changsha 长沙芙蓉国温德姆至尊豪廷大酒店",
                        "Howard Johnson Downtown Hotel Chongqing 重庆渝融豪生酒店",
                        "Howard Johnson Jinling Plaza Lijiang 丽江金林豪生大酒店",
                        "Howard Johnson Agile Plaza Chengdu 成都雅居乐豪生大酒店",
                    ].map((x, i) => {
                        return (
                            <div className="item" key={x}>
                                <div>{i + 1}</div>
                                <div>
                                    {x.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.replace(/[^\u4E00-\u9FA5]/g, "")}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default Income;


// WEBPACK FOOTER //
// ./src/components/table/performanceReview/Compared.js